/** @jsx jsx */

import { Link } from 'gatsby'
import { bool } from 'prop-types'
import { number } from 'prop-types'
import { string } from 'prop-types'
import ReactMarkdown from 'react-markdown'
import { jsx, Flex, Image, Text } from 'theme-ui'
import ArrowRightSmall from '../../../../icons/ArrowRightSmall'
import { limitStringLength } from '../../../../utils/globalHelper'

const Persona = ({
  index,
  image,
  name,
  description,
  url,
  investableAssets,
  isForQuestionCard = false,
}) => {
  const DESC_CHAR_LIMIT = 160

  return isForQuestionCard ? (
    <Flex
      sx={{
        mx: index === 1 ? '16px' : '0',
        flexDirection: 'column',
        width: '100%',
        alignItems: 'center',
        boxShadow: '0px 3px 7px 0px #1013164D',
        padding: '22px',
      }}
    >
      <Flex sx={{ flexDirection: 'row' }}>
        <Image
          sx={{
            borderRadius: '50%',
            height: 'auto',
            objectFit: 'cover',
            width: '65px',
          }}
          src={image}
          alt="Persona placeholder img"
        />

        <Text
          variant="mediumTextBold"
          sx={{
            maxWidth: '158px',
            marginLeft: '20px',
            fontWeight: 400,
            color: 'forest',
            mb: '5px',
          }}
        >
          {name}
        </Text>
      </Flex>

      <Text
        variant="smallText"
        sx={{
          mt: '10px',
          fontWeight: 400,
          color: 'darkGray',
        }}
      >
        <ReactMarkdown>
          {description?.length > DESC_CHAR_LIMIT
            ? limitStringLength(description, DESC_CHAR_LIMIT)
            : description}
        </ReactMarkdown>
      </Text>
    </Flex>
  ) : (
    <Flex
      sx={{
        width: '100%',
        alignItems: 'center',
        gap: '30px',
        boxShadow: '0px 3px 7px 0px #1013164D',
      }}
    >
      <Image sx={{ width: '30%' }} src={image} alt={name} />
      <Flex
        sx={{
          flexDirection: 'column',
          alignItems: 'flex-start',
          width: '70%',
        }}
      >
        <Text
          sx={{
            fontWeight: 400,
            fontSize: '25px',
            color: 'forest',
            mb: '5px',
          }}
        >
          {name}
        </Text>
        <Text
          sx={{
            fontWeight: 600,
            fontSize: '16px',
            color: 'black',
            mb: '12px',
          }}
        >
          {`Investable Assets: ${investableAssets}`}
        </Text>
        <Text
          sx={{
            fontWeight: 400,
            fontSize: '18px',
            mb: '8px',
            paddingRight: '50px',
            color: 'darkGray',
          }}
        >
          {description.length > DESC_CHAR_LIMIT
            ? limitStringLength(description, DESC_CHAR_LIMIT)
            : description}
        </Text>

        <Flex
          sx={{
            gap: '12px',
            alignItems: 'center',
            a: {
              color: 'forest',
              fontWeight: 700,
              fontSize: '14px',
              textTransform: 'uppercase',
            },
          }}
        >
          <Link to={url} target="_blank">
            Launch Persona
          </Link>
          <ArrowRightSmall />
        </Flex>
      </Flex>
    </Flex>
  )
}

Persona.propTypes = {
  index: number,
  image: string,
  name: string,
  description: string,
  url: string,
  investableAssets: string,
  isForQuestionCard: bool,
}

export default Persona
